export default "__VITE_ASSET__MLYckIEl__"